import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { Pagination, PaginationItem, PaginationLink } from "reactstrap";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CustomPagination from "./CustomPagination";

const PaginatedList = ({
  setPaginatedList,
  searchInput,
  selectedSupplier,
  setShowSpinner,
  endPoint,
  endPoint2,
  limit = 100,
  setPurchasePaginatedList,
  setTotalPaid,
  purchaseLimit,
  refresh,
  filters
}) => {
  const auth = useSelector((state) => state.authentication);
  const { userData } = auth;
  // const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const navigate = useNavigate();
  const [resetKey, setResetKey] = useState(0);

  // currentPage, pageSize
 const fetchData = useCallback(async (page) => {
  setShowSpinner(true);

  try {
    // ✅ MAIN ENDPOINT
    if (endPoint) {
      const response = await axios.get(
        `${process.env.REACT_APP_COLLEGE_ERP_API}${endPoint}`,
        {
          params: {
            branch: userData.branch,
            invoice_id: "",
            page,
            limit,
            searchInput,
            supplierId: selectedSupplier,
            startDate: filters?.fromDate,
            endDate: filters?.toDate,
          },
          headers: {
            Authorization: `Bearer ${userData.token}`,
          },
        }
      );

      setPaginatedList(response.data.items);
      setTotalPages(response.data.totalPages);
    }

    // ✅ SECOND ENDPOINT
    if (endPoint2) {
      const response = await axios.get(
        `${process.env.REACT_APP_COLLEGE_ERP_API}${endPoint2}`,
        {
          params: {
            branch: userData.branch,
            invoice_id: "",
            page,
            limit: purchaseLimit,
            searchInput,
            startDate: filters?.fromDate,
            endDate: filters?.toDate,
          },
          headers: {
            Authorization: `Bearer ${userData.token}`,
          },
        }
      );

      const { items, totalPages, totalPaid } = response.data;

      setPurchasePaginatedList(items);
      setTotalPaid(totalPaid);

      if (!endPoint) {
        setTotalPages(totalPages);
      }
    }

  } catch (err) {
    console.error("Error fetching data:", err);

    if (
      err.response?.data?.err?.name === "TokenExpiredError" ||
      err.response?.data?.message === "Unauthorized"
    ) {
      navigate("/");
      sessionStorage.clear();
    }
  } finally {
    setShowSpinner(false);
  }
}, [
  endPoint,
  endPoint2,
  limit,
  purchaseLimit,
  searchInput,
  selectedSupplier,
  filters?.fromDate,
  filters?.toDate,
  userData.branch,
  userData.token,
]);

  useEffect(() => {
    setCurrentPage(1);
    setResetKey((prev) => prev + 1); // always changes
  }, [searchInput, selectedSupplier, refresh]);

useEffect(() => {
  fetchData(currentPage);
}, [currentPage, resetKey, fetchData]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const maxVisiblePages = 4;
  // Calculate the range of visible pages
  let startPage = Math.max(currentPage - Math.floor(maxVisiblePages / 2), 1);
  let endPage = startPage + maxVisiblePages - 1;

  // Adjust if `endPage` exceeds total pages
  if (endPage > totalPages) {
    endPage = totalPages;
    startPage = Math.max(totalPages - maxVisiblePages + 1, 1);
  }

  // Generate visible page numbers
  const visiblePages = Array.from(
    { length: endPage - startPage + 1 },
    (_, index) => startPage + index
  );
  return (
    <div>
       <CustomPagination
  currentPage={currentPage}
  totalPages={totalPages}
  handlePageClick={(page) => setCurrentPage(page)}
/>

    </div>
  );
};

export default PaginatedList;
